import { render, staticRenderFns } from "./entityTypeComponent.vue?vue&type=template&id=9c069d26&"
import script from "./entityTypeComponent.vue?vue&type=script&lang=js&"
export * from "./entityTypeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports